import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled, { consolidateStreamedStyles } from 'styled-components'
import { Form } from 'formsy-react-2'
import R from 'ramda'
import { Row, Col } from 'react-flexbox-grid'
import moment from 'moment'
import {
    Colors, 
    Button, 
    ContextMenu, 
    Table, 
    TableCell, 
    TableHeader, 
    TextInput, 
    TextIcon, 
    Select, 
    DatePicker, 
    Modal, 
    ModalRemove, 
    Dropzone,
    SelectSearch,
    InputTag
} from 'advenio-components'
import TimePicker from '../../../shared/TimePicker'
import LoadingSpinner from '../../../shared/LoadingSpinner'
import { parseShortName, parseFullName, userHasRole } from '../../../utils/Utils'
import InputContainer from 'advenio-components/lib/components/InputContainer/InputContainer'


const ModalStyled = styled.div`
  padding: 40px;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 51px;
  width-bottom:10p;
`
const WarningZone = styled.div`
  flex:1;
  justify-content: flex-start;
  display: flex;
  background: ${Colors.yellow100};
  flex-direction: column;
  color:${Colors.yellowText};
  padding: 16px;
  h3 {
    margin:0;
    margin-bottom: 16px;
  }
`
const WarningRow = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }

`
const ButtonContainer = styled.div`
  font-size: 14px;
  margin-top: 29px;
  margin-left: 57px;
  ${({Submit, update}) => Submit &&`
    display:inherit;
    font-size: 0px;
    margin-top: auto;
    margin-left: ${update ? '270px': '370px'};
  `}
`

const TableContainer = styled.div`
  margin: 8px;
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:#FFFFFF;
  height: 78px;
`
const shifts = [
  {value:1 , label: 'Matutino',id:1},
  {value:2 , label: 'Vespertino',id:2},
]

class ModalReservations  extends Component {
    constructor(props) {
    super(props)
        this.state ={
          modalState:'create',
          width: 0,
          bannerCaution: false,
          isErrorTime: false,
          serviceTypes:[],
          loadingStudent:false,
          shift:1,
          fromDate:null,
          toDate:null
        }
    }   

     componentWillMount(){
      const { serviceTypes, reservation:{ id , to_time, from_time ,from_date ,to_date}} =this.props
      const services = this.renderOptionsServiceTypes(serviceTypes)
      let modalState='create'
      let shift = 2
      let fromDate = moment(moment().add(2,'days')).day() === 6 || moment(moment().add(2,'days')).day() === 0 ?  moment().day(1 + 7).format('YYYY-MM-DD') : null
      let toDate = moment(moment().add(2,'days')).day() === 6 || moment(moment().add(2,'days')).day() === 0 ?  moment().day(1 + 7).format('YYYY-MM-DD') : null

      if(id !== undefined){
        modalState='update'
        const timeTo = Number(to_time.match(/^[0-9]*[^:]/)[0])
        const timeFrom = Number(from_time.match(/^[0-9]*[^:]/)[0])
        if(timeFrom >= 9 && timeTo <= 13){
          shift = 1
        }
      }
      if(to_date !== undefined && from_date !== undefined){
        toDate = to_date
        fromDate = from_date
      }
      this.setState({serviceTypes:services, modalState, shift, toDate, fromDate})
    }

    willSubmit = (data)=> {
        const { postReservation,updateReservation, reservation, child, user, } = this.props
        const { studentsSelectioned ,modalState} = this.state
        // const timeFrom = this.timeFrom.getValue()
        // const timeTo = this.timeTo.getValue()
        let timeFrom = '14:30'
        let timeTo = '18:30'

        delete data.hour 
        delete data.minute
        delete data.student_id
        // if(! (moment(timeFrom,"HH:mm").isBefore(moment(timeTo,"HH:mm"))) ){
        //     this.setState({bannerCaution:true,isErrorTime:true, isErrorStudents:false})
        //     return false
        // }
        if(! (moment(data.to_date).isSameOrAfter(moment().add(2, 'days'))) || 
           ! (moment(data.from_date).isSameOrAfter(moment().add(2, 'days'))) || 
           ! (moment(data.to_date).isSameOrAfter(moment(data.from_date))) ||
           (moment(data.to_date).day() === 0 || moment(data.to_date).day() === 6)||
           (moment(data.from_date).day() === 0 || moment(data.from_date).day() === 6)
        ){
          this.setState({bannerCaution:true,isErrorTime:false,isErrorStudents:false})
          return false
        }
        if(Number(data.shift_id) === 1){
          timeFrom = '09:00'
          timeTo = '13:00'
        }

    
        let dataSend = {...data,
            from_time: timeFrom,
            to_time: timeTo,
            service_id:Number(data.service_id),
        }
        if(child.center) {
          dataSend = {
            ...dataSend,
            center_id: Number(child.center.id),
            parent_id: Number(user.userable_id)
          }
        }
        if(reservation.id !== undefined){
          dataSend = {
            ...dataSend,
            id:reservation.id,
          }
        }

        if(modalState === 'create'){
          postReservation(child.id,dataSend)
        }
        else if(modalState === 'update'){
          updateReservation(reservation.id, dataSend)
        }
    }

    renderOptionsServiceTypes = (services = [] ) => {
      const Options = [{ id:0, label: 'Seleccione servicio', value:0}]
      return Options.concat(services.map(s=> ({
          id: s.id,
          label: s.name,
           value: s.id
        })))
    }

    render() {
        const { 
          isOpen
          , isClose
          , child
          , loading 
          , user
          , loadingRequest
          , reservation:{
            id
            ,title
            ,service_id 
            ,from_date
            ,to_date
            ,from_time
            ,to_time
          }
          ,deleteReservation
        } = this.props
        const { 
          bannerCaution
          , isErrorTime
          , serviceTypes
          , modalState
          , shift
          , toDate
          , fromDate
        } = this.state

        return(
        <Modal 
        isOpened={isOpen} 
        headerTitle={`${modalState === 'create' ? 'Agregar':'Actualizar'} Reservación`}
        onClose={isClose}
        >
          <ModalStyled>
            <Form  
                ref={(form) => { this.form = form }}  
                onValidSubmit={this.willSubmit}
            >
               <Row>
                 <Col xs={6}>
                   <Select
                     name="service_id"
                     label="Tipo de Servicio"
                     value={service_id || 2}
                     options={serviceTypes}
                     hideEmptyHelpBlock
                     required
                   />
                </Col>
                 <Col xs={6}>
                  <TextInput
                    name='student_id'
                    label='Alumno'
                    value={parseFullName(child)}
                    disabled
                    required
                  />
                 </Col>
               </Row>
              <Row>
                <Col xs={6}>
                  <DatePicker 
                    name="from_date" 
                    label="Fecha Inicio" 
                    value={fromDate || moment().format('YYYY-MM-DD')} 
                    required
                    disableBeforeToday
                  />
                </Col>
                <Col xs={6}>
                  <DatePicker 
                    name="to_date" 
                    label="Fecha Fin" 
                    value={toDate || moment().format('YYYY-MM-DD')} 
                    required
                    disableBeforeToday
                  />
                </Col>   
              </Row>
              <Row>
              <Col xs={6}>
                   <Select
                     name="shift_id"
                     label="Tipo de Turno"
                     value={shift}
                     options={shifts}
                     hideEmptyHelpBlock
                     required
                     help={'Matutino: 09:00-13:00 Vespertino: 14:30-18:30'}
                   />
                </Col>
                {/* <Col xs={6}>
                    <TimePicker
                      name="from_time"
                      label="Hora Inicio"
                      hideEmptyHelpBlock
                      required
                      value={from_time || null}
                      ref={(timeFrom) => { this.timeFrom = timeFrom }}
                    />
                </Col>
                <Col xs={6}>
                <TimePicker
                  name="to_time"
                  label="Hora Fin"
                  hideEmptyHelpBlock
                  required
                  value={to_time || null}
                  ref={(timeTo) => { this.timeTo = timeTo }}
                />
                </Col>  */}
              </Row>
              {bannerCaution&&(
                  <WarningZone>
                      <h3>Precaución</h3>
                      <WarningRow>
                        <div>
                        {<span>Asegurate de que la <b>{isErrorTime ?'Hora':'Fecha'} Fin</b> sea mayor {!isErrorTime ? 'o igual':''} que <b>{isErrorTime ?'Hora':'Fecha'} Inicio</b>,
                        que la reservación sea <b>3 dias</b> de anticipación
                        y que solo sean dias habiles.</span>}
                        </div>
                      </WarningRow>
                    </WarningZone>
              )}
              <div style={{marginTop:30}}>
                <Row>
                  <ButtonContainer Submit update={modalState === 'update'}>
                    {modalState === 'update'?
                      <Col xs={4}>
                        <Button onClick={()=> deleteReservation(id,true)} danger loading={loading} >Eliminar</Button>
                      </Col>
                      :
                      <div></div>
                    }
                    <Col xs={modalState === 'update' ? 4 : 6}>
                      <Button onClick={isClose}  loading={loading} >Cancelar</Button>
                    </Col>
                    <Col xs={modalState === 'update' ? 4 : 6}>
                      <Button primary type="submit" loading={loading}>Guardar</Button>
                    </Col>
                  </ButtonContainer>
                </Row>
              </div>
            </Form>
          </ModalStyled>
        </Modal>)
    }
}

export default ModalReservations



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Reservations/ModalReservations.jsx